<template>
				<div class="toast" :class="{closed:!show}">
					<div class="bd">
						<div></div>
						<p class="cnt">{{message}}</p>
					</div>
				</div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      show: false
    }
  }
}
</script>

<style scoped>
.toast {
    position: fixed;
    z-index: 9999;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: transparent;
}
.bd {
    line-height: 1.5;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    max-width: 90%;
    padding: .266667rem;
    -webkit-transition: opacity .6s linear;
    -moz-transition: opacity .6s linear;
    transition: opacity .6s linear;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    text-align: center;
    opacity: 1;
    color: #fff;
    -webkit-border-radius: .066667rem;
    border-radius: .066667rem;
    background-color: rgba(0,0,0,.8);
}
.closed{
  display: none;
}


.bd.big {
  width: 2.666667rem;
  height: 2.666667rem;
  padding-top: 0.4rem;
}

.bd.big .cnt {
  position: absolute;
  bottom: 0.266667rem;
  left: 0;
  right: 0;
  margin: auto;
}

.bd.is-closing {
  opacity: 0;
}

.cnt{
  text-align: center;
}

[data-dpr="1"] .cnt {
  font-size: 14px;
}

[data-dpr="2"] .cnt {
  font-size: 28px;
}

[data-dpr="3"] .cnt {
  font-size: 42px;
}
</style>


// WEBPACK FOOTER //
// src/plugins/Toast/index.vue